function Stepper({ steps = [], currentStep }) {
  const currentIndex = steps.findIndex((s) => s.key === currentStep);
  const progressPercent = (currentIndex / (steps.length - 1)) * 100;

  return (
    <div className="mb-10">
      {/* Labels */}
      <div className="flex justify-between mb-2">
        {steps.map((step, index) => {
          const isDoneOrActive = index <= currentIndex;
          return (
            <span
              key={step.key}
              className={`text-sm font-semibold ${
                isDoneOrActive ? "text-blue-600" : "text-gray-400"
              }`}
            >
              {step.label}
            </span>
          );
        })}
      </div>

      {/* Progress bar */}
      <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-blue-600 transition-all duration-500"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}

export default Stepper;




// import React, { useMemo } from "react";
// import { motion } from "framer-motion";

// export default function Stepper({ steps = [], currentStep }) {
//   /* ------------------------------------------------------
//      STEP INDEX (derived from currentStep)
//   -------------------------------------------------------*/
//   const stepIndex = useMemo(() => {
//     return steps.findIndex((s) => s.key === currentStep);
//   }, [steps, currentStep]);

//   const maxIndex = steps.length - 1;

//   /* ------------------------------------------------------
//      Progress calculations (UNCHANGED LOGIC)
//   -------------------------------------------------------*/
//   const bubblePercent = (stepIndex / maxIndex) * 100;
//   const barPercent = bubblePercent + 2; // visual alignment tweak

//   return (
//     <motion.div
//       initial={{ y: -70, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.45, ease: [0.25, 1, 0.35, 1] }}
//       className="
//         fixed top-0 left-[260px] w-[calc(100%-260px)] z-[9999]
//         rounded-b-3xl
//         backdrop-blur-2xl bg-white/20
//         border-b border-white/30
//         shadow-[0_8px_30px_rgba(0,0,0,0.10)]
//       "
//     >
//       <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-b from-transparent to-white/0" />

//       <div className="max-w-4xl mx-auto px-6 py-4">

//         {/* STEP LABELS */}
//         <div className="flex justify-between mb-3">
//           {steps.map((step, i) => (
//             <motion.span
//               key={step.key}
//               className={`text-sm font-medium ${
//                 i === stepIndex ? "text-blue-700" : "text-gray-400"
//               }`}
//               animate={{
//                 opacity: i === stepIndex ? 1 : 0.6,
//                 scale: i === stepIndex ? 1.06 : 1
//               }}
//               transition={{ duration: 0.25 }}
//             >
//               {step.label}
//             </motion.span>
//           ))}
//         </div>

//         {/* LIQUID CAPSULE */}
//         <div
//           className="
//             relative w-full h-6 rounded-full overflow-hidden
//             bg-white/40 backdrop-blur-xl
//             border border-white/50 shadow-inner
//           "
//         >
//           {/* Blue Fill BAR */}
//           <motion.div
//             className="
//               absolute top-0 left-0 h-full rounded-full
//               bg-gradient-to-r from-blue-400 via-blue-600 to-blue-700
//               shadow-[0_0_15px_rgba(60,140,255,0.6)]
//             "
//             initial={{ width: 0 }}
//             animate={{ width: `${barPercent}%` }}
//             transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
//           />

//           {/* Bubble */}
//           <motion.div
//             className="
//               absolute top-0 h-6 w-10 rounded-full
//               backdrop-blur-3xl bg-white/40
//               border border-white/60
//               shadow-[0_4px_12px_rgba(255,255,255,0.6)]
//             "
//             animate={{ left: `calc(${bubblePercent}% - 20px)` }}
//             transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
//           />

//           {/* Shine */}
//           <motion.div
//             className="
//               absolute top-0 left-0 h-full w-1/4
//               bg-gradient-to-r from-white/50 to-transparent
//               blur-md opacity-70
//             "
//             animate={{ x: ["-25%", "120%"] }}
//             transition={{
//               duration: 2.2,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//         </div>
//       </div>
//     </motion.div>
//   );
// }
